import { render, staticRenderFns } from "./addCartPhone2.vue?vue&type=template&id=f7702be8&scoped=true"
import script from "./addCartPhone2.vue?vue&type=script&lang=js"
export * from "./addCartPhone2.vue?vue&type=script&lang=js"
import style0 from "./addCartPhone2.vue?vue&type=style&index=0&id=f7702be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7702be8",
  null
  
)

export default component.exports